import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import WidgetHeader from '../Widget/WidgetHeader';
import AnswerButton from '../../components/Assessment/AnswerButton';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';

import ShareDrawer from '../../components/ShareDrawer';

import { isLongText } from '../../components/Shared/commonFunctions';

import { onGoToForm } from './actions.js';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';

import { Container, RockTheVoteLabel } from '../DefaultStyles/Details';
import {
    Body,
    Title,
    Content,
    Description,
    DetailsContainer,
    Details,
    Footer
} from '../DefaultStyles/Shared';

import { setOverlayPartnerVisible } from '../Widget/actions';

import rockTheVoteLogo from '../../assets/images/rock-the-vote-logo.png';
import { RockTheVoteDetails } from '../../components/Shared/rockTheVoteDetails';

class ElectionReminderDetails extends React.Component {
    componentDidMount() {
        this.forceUpdate();
    }
    render() {
        return (
            <Container>
                <Overlay />
                <OverlayPublisher />
                <OverlayPartner
                    transitionType="right-to-left"
                    logo={rockTheVoteLogo}
                    name={this.props.rockTheVoteTitle}
                    description={this.props.rockTheVoteDescription}
                />
                <Body>
                    <WidgetHeader />
                    <Content isContactAction={false} isSingleAction={true}>
                        <Title
                            isLongText={isLongText(this.props.title, 60)}
                            isExtraLongText={isLongText(this.props.title, 95)}
                            onClick={e => {
                                this.props.setOverlayPartnerVisible(true, e, false);
                            }}
                            dangerouslySetInnerHTML={{
                                __html: this.props.title
                            }}
                        />
                        <DetailsContainer>
                            <Details>
                                <Description
                                    onClick={e =>
                                        this.props.setOverlayPartnerVisible(true, e, false)
                                    }
                                    isLongText={isLongText(this.props.subTitle, 90)}
                                    isExtraLongText={isLongText(this.props.subTitle, 160)}
                                    dangerouslySetInnerHTML={{
                                        __html: this.props.subTitle
                                    }}
                                />
                                <RockTheVoteLabel
                                    onClick={e =>
                                        this.props.setOverlayPartnerVisible(true, e, true)
                                    }
                                >
                                    {this.props.rockTheVoteLabel}
                                </RockTheVoteLabel>
                            </Details>
                        </DetailsContainer>
                    </Content>
                    <AutoScalingButtonSet mobileStyled={true} mobileLeftPosition={8}>
                        <AnswerButton
                            text={this.props.registerButtonText}
                            useLoadingSpinner={false}
                            onClick={() => {
                                this.props.onGoToForm(
                                    this.props.actionIdentifier,
                                    this.props.actionInitiated
                                );
                            }}
                        />
                    </AutoScalingButtonSet>
                    <Footer>
                        <ShareDrawer backgroundColor={'#fff'} />
                    </Footer>
                </Body>
            </Container>
        );
    }
}

ElectionReminderDetails.propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
    actionIdentifier: PropTypes.string.isRequired,
    actionInitiated: PropTypes.bool.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    rockTheVoteTitle: PropTypes.string,
    rockTheVoteDescription: PropTypes.string,
    registerButtonText: PropTypes.string.isRequired,
    onGoToForm: PropTypes.func.isRequired,
    rockTheVoteLabel: PropTypes.string.isRequired
};

export default connect(
    state => {
        const defaultTitle = 'Sign up to receive local election updates.';
        const defaultSubtitle =
            'By staying informed of key dates and events, you can be sure you’re ready for the next election.';

        return {
            title: state.widget.activeAction.title || defaultTitle,
            subTitle: state.widget.activeAction.text || defaultSubtitle,
            actionIdentifier: state.widget.activeAction.identifier,
            actionInitiated: state.electionReminder.actionInitiated,
            rockTheVoteTitle: RockTheVoteDetails.title,
            rockTheVoteDescription: RockTheVoteDetails.description,
            rockTheVoteLabel: RockTheVoteDetails.label,
            registerButtonText: state.widget.activeAction.customButtonText || 'SIGN UP'
        };
    },
    {
        setOverlayPartnerVisible,
        onGoToForm
    }
)(ElectionReminderDetails);



// WEBPACK FOOTER //
// ./src/containers/ElectionReminder/ElectionReminderStart.jsx